import React, { useState, useEffect } from 'react';
import {
  ActionWrapper,
  ModalWrapper,
  NoteFooter,
  PageContainerWrapper,
  TablePlus,
} from '../../../../components';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';

import {
  smsMessageBreadcrumb,
  smsMessageTableColumn,
} from '../../../../services/Columns';
import useTable from '../../../../hooks/useTable.hook';
import {
  listSmsService,
  viewShortCodeService,
} from '../../../../services/EmailMessage/emailTemplate.service';
import { accessRoute } from '../../../../routes/EmailSetting';
import ShortCodeModal from './shortCodeModal';
import { getApiData } from '../../../../hooks/useGetApi.hook';
import { getActions } from '../../../../services/index.service';

function ListSMS() {
  const { t } = useTranslation();
  const [shortCodeData, setShortCodeData] = useState([]);
  const [state, setState] = useState({
    modal: null,
  });
  const { modal } = state;
  const extraQuery = {
    smsType: 'default',
  };
  const isScope = false;
  // Get table data by api
  const [tableHandler, tableProps] = useTable(
    listSmsService,
    extraQuery,
    false,
    false,
    false,
    false,
    false,
    isScope
  );
  const {
    data,
    isLoading,
    count,
    page,
    noOfPages,
    sizePerPage,
    filter,
    sortBy,
    sortType,
  } = tableProps;
  const { onFilterChange, onExport, onFilterResetChange } = tableHandler;

  // for breadcrumb
  const breadcrumbData = smsMessageBreadcrumb();

  // For action with column
  function onAction(e, handler, item) {
    e.preventDefault();
    if (handler) handler(item);
  }

  const actionFormatter = (options) => {
    return (
      <ActionWrapper>
        {options?.map((item, key) => {
          return (
            <li
              onClick={(e) => onAction(e, item?.handler, item)}
              key={key}
              className="action_list"
              action={item?.action}
            >
              <Link
                to={generatePath(accessRoute.EDIT_SMS_TEMPLATES.path, {
                  id: item?.id,
                })}
              >
                <em className={item?.icon} /> {item?.name}
              </Link>
            </li>
          );
        })}
      </ActionWrapper>
    );
  };

  // Columns
  const columns = smsMessageTableColumn({
    onFilterChange: onFilterChange,
    filter,
    Action: (props) =>
      actionFormatter([
        {
          name: t('text.common.edit'),
          icon: 'icon ni ni-edit',
          id: props?.row?.id,
          action: getActions('EDIT').value,
        },
      ]),
  });

  const modalForm = {
    add: <ShortCodeModal onCancel={onCancel} data={shortCodeData} />,
  };

  const btn = {
    add: {
      name: t('text.emailMessage.shortCodes'),
      handler: () => {
        setState({ ...state, modal: 'short-code' });
      },
    },
    csvExport: { handler: () => onExport('', columns) },
  };
  function onCancel() {
    setState({ ...state, modal: null, modalId: null });
  }

  useEffect(() => {
    getApiData({
      service: viewShortCodeService,
      setData: setShortCodeData,
    });
  }, []);

  return (
    <>
      <PageContainerWrapper
        breadcrumb={breadcrumbData}
        btn={btn}
        heading={t('text.emailMessage.SMSTemplates')}
        btnText="Short Codes"
        btnIcons="icon ni ni-info-fill"
      >
        <ModalWrapper
          extraClassName="modal-xl"
          heading={t('text.emailMessage.smsShortCodes')}
          onCancel={onCancel}
          content={modalForm['add']}
          show={['short-code'].includes(modal)}
        />

        <TablePlus
          hasLimit
          noOfPage={noOfPages}
          sizePerPage={sizePerPage}
          page={page}
          count={count}
          tableData={data}
          tableColumns={columns}
          selectRow
          tableLoader={isLoading}
          showAction={false}
          onFilterResetChange={onFilterResetChange}
          filter={filter}
          sortBy={sortBy}
          sortType={sortType}
        />
        <NoteFooter title={t('text.common.notes')}>
          <li>{t('text.emailMessage.noteSmsOne')}</li>
          <li>{t('text.emailMessage.noteSmsTwo')}</li>
        </NoteFooter>
      </PageContainerWrapper>
    </>
  );
}

export default ListSMS;
